import React, { useState, useEffect, useContext } from "react";
// Components
import DisputesHeaderDark from "../Components/DisputesHeaderDark";
import DisputePageTitle from "../Components/DisputePageTitle";
import { Col, Row, Table } from "react-bootstrap";
import "react-quill/dist/quill.snow.css";
import axios from "axios";

import { motion } from "framer-motion";
import { Modal } from "react-bootstrap";

import { AuthContext } from "../AuthProvider";

import TextEditor from "../Components/TextEditor";

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "align",
];

const getSubscribers = async (setSubscribers, setError) => {
  const accessToken = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}subscribers/`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    setSubscribers(
      response.data.sort((a, b) => {
        const textA = a.email.toUpperCase();
        const textB = b.email.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      })
    );
  } catch (error) {
    setError("Error fetching subscribers!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const getHelp = async (setHelp, setError) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}help/${encodeURIComponent(
        "Manage Newsletter"
      )}/`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    setHelp(response.data);
  } catch (error) {
    setError("Error fetching help!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const getNewsletters = async (setNewsletters, setError, setWelcome) => {
  const accessToken = localStorage.getItem("accessToken");
  try {
    const response = await axios.get(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}newsletters/`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    setNewsletters(response.data);
    setWelcome(
      response.data.filter(
        (newsletter) => newsletter.title === "Subscription Welcome Email"
      )[0]
    );
  } catch (error) {
    setError("Error fetching newletters!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const getFiles = async (setFiles, setError) => {
  try {
    const response = await axios.get(
      "https://www.googleapis.com/drive/v3/files",
      {
        params: {
          q: "'15JSF0F4hEfYoHJmKfXv5Cy_M0ti_-HMH' in parents",
          key: window.__RUNTIME_CONFIG__.REACT_APP_GOOGLE_DRIVE_API,
          fields: "files(id, name, webViewLink, mimeType)",
          supportsAllDrives: true,
          includeItemsFromAllDrives: true,
        },
      }
    );

    setFiles(response.data.files);
  } catch (error) {
    console.error(
      "Error fetching files:",
      error.response?.data || error.message
    );
    setError("Error fetching files from Google Drive!");
    setTimeout(() => {
      setError(null);
    }, "2000");
  }
};

const handleSendNewsletter = async (
  value,
  setSuccess,
  setError,
  setValue,
  title,
  setTitle
) => {
  const confirm = window.confirm("Please confirm sending out of newsletter");
  const date = new Date().toISOString().split("T")[0];

  if (confirm) {
    const accessToken = localStorage.getItem("accessToken");
    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}send-newsletter/`,
        { content: value, date: date, title: title },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setValue("");
      setTitle("");
      setSuccess("Successfully sent newsletter!");
      setTimeout(() => {
        setSuccess(null);
      }, 2000);
    } catch (error) {
      setError("Error while sending newsletter");
      setTimeout(() => {
        setError(null);
      }, 2000);
    }
  }
};

const handleDeleteSubscriber = async (
  subscriber,
  setError,
  setSuccess,
  setSubscribers
) => {
  const accessToken = localStorage.getItem("accessToken");
  try {
    if (
      window.confirm(
        `Are you sure you want to delete subscriber ${subscriber.email}? This cannot be undone!`
      )
    ) {
      const response = await axios.delete(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}subscribers/${subscriber.subscriberid}/delete/`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      setSuccess(`Deleted subscriber ${subscriber.email}!`);
      getSubscribers(setSubscribers, setError);
      setTimeout(() => {
        setSuccess(null);
      }, "2000");
    }
  } catch (error) {
    setError(error.message);
    console.log(error.message);
    setTimeout(() => {
      setError(null);
    }, "2000");
    console.error(
      "Error deleting subscriber:",
      error.response?.data || error.message
    );
  }
};

const handleUpdateWelcome = async (
  welcome,
  welcomeValue,
  setSuccess,
  setError,
  setWelcomeValue
) => {
  const accessToken = localStorage.getItem("accessToken");
  const data = {
    content: welcomeValue,
  };

  try {
    const response = await axios.patch(
      `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}newsletters/${welcome.id}/update/`,
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    if (response.data?.error) {
      setError("Error while updating welcome email!");
    } else {
      setSuccess("Welcome Email Updated!");
      setTimeout(() => {
        setSuccess(null);
      }, "2000");
    }
  } catch (error) {
    if (error.response) {
      setError("Error while updating welcome email!");
      setTimeout(() => {
        setError(null);
      }, "2000");
    } else if (error.request) {
      console.error("Network Error: No response received");
      setError("Error while updating welcome email!");
      setTimeout(() => {
        setError(null);
      }, "2000");
    } else {
      console.error("Unexpected Error:", error.message);
      setError("Error while updating welcome email!");
      setTimeout(() => {
        setError(null);
      }, "2000");
    }
  }
};

export default function ManageNewsletter() {
  const [subscribers, setSubscribers] = useState(null);
  const [newsletters, setNewsletters] = useState(null);
  const [showSubscribers, setShowSubscribers] = useState(false);
  const [creating, setCreating] = useState(false);
  const [files, setFiles] = useState([]);
  const [value, setValue] = useState();
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [selectedNewsletter, setSelectedNewsletter] = useState(null);
  const [title, setTitle] = useState("");
  const [editing, setEditing] = useState(false);
  const [welcome, setWelcome] = useState(null);
  const [welcomeValue, setWelcomeValue] = useState("");
  const [help, setHelp] = useState(null);
  const [helping, setHelping] = useState(false);

  const { isLoggedIn, isAdmin, loading } = useContext(AuthContext);

  useEffect(() => {
    getHelp(setHelp, setError);
    getNewsletters(setNewsletters, setError, setWelcome, setWelcomeValue);
    getSubscribers(setSubscribers, setError);
    getFiles(setFiles, setError);
  }, [success]);

  return (
    <>
      <DisputesHeaderDark />
      {isAdmin && (
        <>
          <div className="relative">
            <DisputePageTitle title="Manage Newsletter" />
            <button
              className="absolute bottom-[-50px] right-[16px] z-50"
              onClick={() => {
                setHelping(true);
              }}
            >
              <i className="fa-solid fa-circle-question text-[#ef8d23] text-[2rem]"></i>
            </button>
          </div>
          <Modal
            show={helping}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton onClick={() => setHelping(false)}>
              <Modal.Title className="text-[#ef8d23]">
                <i className="fa-solid fa-circle-question text-[#ef8d23] text-[2rem] pe-3"></i>
                {help?.model} Help
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="ql-editor">
                <div dangerouslySetInnerHTML={{ __html: help?.content }}></div>
              </div>
            </Modal.Body>
          </Modal>
          <section className="pb-[160px] overflow-hidden cover-background ">
            <Row>
              <Col
                lg={3}
                className=" p-5 pt-4"
                data-test="notices-manage-navbar"
              >
                <button
                  className="w-100 bg-[#ef8d23] text-white mb-3 py-2 hover:bg-[#ef8d23cc] block"
                  data-test="notices-manage-new"
                  type="submit"
                  onClick={() => {
                    setCreating(true);
                    setShowSubscribers(false);
                    setSelectedNewsletter(null);
                    setEditing(false);
                  }}
                >
                  Send Newsletter
                </button>

                <div className="bg-lightgray p-4 text-dark">
                  <p
                    className={`${
                      editing ? "bg-[#ef8d23] text-white" : ""
                    } p-1 hover:text-[#ef8d23]`}
                    onClick={() => {
                      setEditing(true);
                      setCreating(false);
                      setShowSubscribers(false);
                      setSelectedNewsletter(null);
                      setWelcomeValue(welcome.content);
                    }}
                  >
                    Manage Welcome Email
                  </p>
                  <p
                    className={`${
                      showSubscribers ? "bg-[#ef8d23] text-white" : ""
                    } p-1 hover:text-[#ef8d23]`}
                    onClick={() => {
                      setCreating(false);
                      setShowSubscribers(true);
                      setSelectedNewsletter(null);
                      setEditing(false);
                    }}
                  >
                    View Subscribers
                  </p>

                  <div className="max-h-screen overflow-y-scroll">
                    {newsletters &&
                      newsletters.map((newsletter) =>
                        newsletter.title !== "Subscription Welcome Email" ? (
                          <p
                            key={newsletter.id}
                            className={`${
                              selectedNewsletter?.id === newsletter.id
                                ? "bg-[#ef8d23] text-white"
                                : ""
                            } p-1 hover:text-[#ef8d23]`}
                            onClick={() => {
                              setCreating(false);
                              setShowSubscribers(false);
                              setSelectedNewsletter(newsletter);
                            }}
                          >
                            {newsletter.date}
                          </p>
                        ) : null
                      )}
                  </div>
                </div>
              </Col>
              <Col lg={8} className="p-5">
                {success && (
                  <motion.div
                    initial={{
                      scale: 0.8,
                      opacity: 0,
                    }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {success && (
                      <div
                        className="my-3 p-3 rounded text-[#ef8d23]"
                        style={{ border: "2px solid #ef8d23" }}
                      >
                        {success}
                      </div>
                    )}
                  </motion.div>
                )}
                {error && (
                  <motion.div
                    initial={{
                      scale: 0.8,
                      opacity: 0,
                    }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{
                      duration: 0.3,
                      ease: "easeOut",
                    }}
                  >
                    {error && (
                      <div
                        className="my-3 p-3 rounded text-danger"
                        style={{ border: "2px solid red" }}
                      >
                        {error}
                      </div>
                    )}
                  </motion.div>
                )}

                {showSubscribers && (
                  <>
                    <Table>
                      <thead>
                        <tr>
                          <th>Email</th>
                          <th>Date Subscribed</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subscribers &&
                          subscribers.map((sub) => {
                            return (
                              <tr>
                                <td>{sub.email}</td>
                                <td>{sub.date}</td>
                                <td>
                                  <button
                                    onClick={() => {
                                      handleDeleteSubscriber(
                                        sub,
                                        setError,
                                        setSuccess,
                                        setSubscribers
                                      );
                                    }}
                                  >
                                    <i class="fa-solid fa-trash text-[#dc3545] hover:text-[#dc3545cc] "></i>
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </>
                )}

                {creating && (
                  <>
                    <input
                      placeholder="Enter email subject e.g. DomainDisputes Newsletter April 2025"
                      className="border p-3 w-100 mb-3"
                      name="title"
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    ></input>
                    {/* <label htmlFor="title" className="block mt-4">Email Content</label> */}
                    <TextEditor
                      value={value}
                      setValue={setValue}
                      formats={formats}
                    />

                    <button
                      class="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                      onClick={() =>
                        handleSendNewsletter(
                          value,
                          setSuccess,
                          setError,
                          setValue,
                          title,
                          setTitle
                        )
                      }
                    >
                      Send Newsletter
                    </button>
                  </>
                )}
                {editing && (
                  <>
                    <TextEditor
                      value={welcomeValue}
                      setValue={setWelcomeValue}
                      formats={formats}
                    />

                    <button
                      class="mt-3 text-white bg-[#ef8d23] py-1 px-3 hover:bg-[#ef8d23cc]"
                      onClick={() =>
                        handleUpdateWelcome(
                          welcome,
                          welcomeValue,
                          setSuccess,
                          setError,
                          setWelcomeValue
                        )
                      }
                    >
                      Update
                    </button>
                  </>
                )}

                {selectedNewsletter && (
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: selectedNewsletter.content,
                      }}
                    ></div>
                  </>
                )}
              </Col>
            </Row>
          </section>
        </>
      )}
      {!isLoggedIn && <DisputePageTitle title="Unauthorized" />}
      {isLoggedIn && !isAdmin && <DisputePageTitle title="Unauthorized" />}
    </>
  );
}
